import { component } from 'picoapp';

export default component((node) => {
  const input = document.getElementById('copy-paste-input-handler');
  const text = node.dataset.content;

  const copy = (e) => {
    e.preventDefault(); // Prevents redirect when button is contained in a link element

    node.classList.add('copied-to-clipboard');

    input.value = text;
    input.select();

    window.navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
      if (result.state === 'granted') {
        window.navigator.clipboard.writeText(input.value);
      } else {
        document.execCommand('copy');
      }
    });

    setTimeout(() => {
      node.classList.remove('copied-to-clipboard');
    }, 1000);
  };

  node.addEventListener('click', copy);
});
